export function normalizeUid(raw) {
  return String(raw || "").replace(/[\s:\-]/g, "").toUpperCase();
}

// Generic adapter interface — future WebSerial/WebUSB/local bridge adapters implement the same shape
export class NFCReaderAdapter {
  connect() {}
  disconnect() {}
  getStatus() { return "disconnected"; }
  onCardDetected(cb) { this._cb = cb; }
  emit(uid) { if (this._cb) this._cb(normalizeUid(uid)); }
}

// Mode 1 — keyboard emulation: USB readers type the UID followed by Enter.
// Heuristic: burst of fast keystrokes (<= maxKeyInterval ms apart) terminated by Enter.
export class KeyboardEmulationAdapter extends NFCReaderAdapter {
  constructor({ minLength = 4, maxKeyInterval = 80 } = {}) {
    super();
    this.minLength = minLength;
    this.maxKeyInterval = maxKeyInterval;
    this.buffer = "";
    this.lastKey = 0;
    this.connected = false;
    this.handler = this.handler.bind(this);
  }

  handler(e) {
    // Ignora la digitazione manuale nei campi editabili (ricerca, form): solo i lettori HID
    // producono burst rapidissimi su body. Evita di dirottare l'invio dei form.
    const t = e.target;
    if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "SELECT" || t.isContentEditable)) {
      this.buffer = "";
      return;
    }
    const now = Date.now();
    if (now - this.lastKey > this.maxKeyInterval) this.buffer = "";
    this.lastKey = now;
    if (e.key === "Enter") {
      if (this.buffer.length >= this.minLength) {
        const uid = this.buffer;
        this.buffer = "";
        e.preventDefault();
        e.stopPropagation();
        this.emit(uid);
      }
      this.buffer = "";
      return;
    }
    if (e.key.length === 1 && /[a-zA-Z0-9]/.test(e.key)) this.buffer += e.key;
    else if (e.key.length === 1) this.buffer = "";
  }

  connect() {
    window.addEventListener("keydown", this.handler, true);
    this.connected = true;
  }

  disconnect() {
    window.removeEventListener("keydown", this.handler, true);
    this.connected = false;
  }

  getStatus() { return this.connected ? "ready" : "disconnected"; }
}

// Mode 2 — stub for future direct device connection (WebSerial / WebUSB / local bridge)
export class WebSerialAdapter extends NFCReaderAdapter {
  connect() { throw new Error("WebSerial adapter not implemented yet"); }
  getStatus() { return "unavailable"; }
}
